import {
  useLayoutEffect,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { loadModules } from "esri-loader";
import useEsri from "../hooks/useEsri";
import "./OsgbBaseMapGallery.css";
import { APP_SETTINGS } from "../settings";

const { GIS_SERVER } = APP_SETTINGS;
const { NI } = GIS_SERVER;

const layerOptionsPM = {
  id: null,
  url: "",
  outFields: ["*"],
  visible: false,
};
const niGreyIds = ["ni_grey_1", "ni_grey_2", "ni_grey_3"];
const niOpenCartoIds = ["ni_opencarto_1", "ni_opencarto_2", "ni_opencarto_3"];
let basemapGallery = null;

const OsgbBaseMapGallery = ({ basemapCollection, LoadingPlaceholder }) => {
  const [loading, setLoading] = useState(true);
  const baseMapGalleryRef = useRef();
  const { esriLoader, addLayer, setLayerVisible } = useEsri();

  const addNILayers = useCallback(
    (layerUrl, layerIds) => {
      if (!layerIds.length) return;
      layerIds.forEach((layerId, index) => {
        addLayer({
          ...layerOptionsPM,
          legendEnabled: false,
          id: layerId,
          url: layerUrl + "/" + index,
        });
      });
    },
    [addLayer]
  );

  const niLayersVisible = useCallback(
    (layerIdsToHide, visible) => {
      layerIdsToHide.forEach((layerId) => {
        setLayerVisible(layerId, visible);
      });
    },
    [setLayerVisible]
  );

  useLayoutEffect(() => {
    if (!esriLoader || !basemapCollection) return;
    const modulesToLoad = [
      "esri/widgets/BasemapGallery",
      "esri/widgets/BasemapGallery/support/LocalBasemapsSource",
    ];
    loadModules(modulesToLoad).then(([BasemapGallery, LocalBasemapsSource]) => {
      const UKBasemaps = new LocalBasemapsSource({
        basemaps: [...basemapCollection],
      });
      basemapGallery = new BasemapGallery({
        source: UKBasemaps,
        view: esriLoader.view,
        container: baseMapGalleryRef.current,
      });

      basemapGallery.watch("activeBasemap", (newValue) => {
        switch (newValue.title) {
          case "OS Open Carto":
          case "OS Open Rasters":
          case "GB Dark Grey":
            niLayersVisible(niGreyIds, false);
            niLayersVisible(niOpenCartoIds, true);
            break;

          default:
            niLayersVisible(niGreyIds, true);
            niLayersVisible(niOpenCartoIds, false);
            break;
        }
      });
      setLoading(false);
    });
    return () => {};
  }, [esriLoader, basemapCollection, niLayersVisible]);

  useEffect(() => {
    if (!basemapCollection) return;
    addNILayers(NI["OS_GREY"], niGreyIds);
    addNILayers(NI["OS_OPENCARTO"], niOpenCartoIds);
  }, [basemapCollection, addNILayers]);

  useEffect(() => {
    if (!basemapCollection) return;
    niLayersVisible(niGreyIds, true); // defualt to grey
  }, [basemapCollection, niLayersVisible]);

  return (
    <div
      data-testid="basemap-gallery-test"
      className="esri-basemap-gallery-horizontal"
    >
      {loading && LoadingPlaceholder}
      <div ref={baseMapGalleryRef}></div>
    </div>
  );
};

export default OsgbBaseMapGallery;
